import React, { useContext } from 'react';
import { AppContext } from '../AppContext';

const AccessRole = ({ children, allowedRoles }) => {
  const { getCurrentUser } = useContext(AppContext);
  const user = getCurrentUser() || {};
  if (allowedRoles?.includes(user?.workspaceRole)) {
    return <div>{children}</div>;
  }
  return null;
};

export default AccessRole;
